import React, { useState } from 'react'
import './Form.css'
import { useLogin } from '../hooks/useLogin'

const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [type, setType] = useState('password')
    const { login, isLoading, error } = useLogin()

    const handleSubmit = async(e) => {
        e.preventDefault()
        console.log({email, password});

       await login(email, password)
    }

    const changeType = (e) => {
        e.preventDefault()
        if(type === 'password') setType('text')
        else setType('password')
    }

    // useEffect(() => {
    //     setEmail('')
    //     setPassword('')
    // }, [])

  return (
    <form className='form'>
    <h3>Log In</h3>
    <label>Email : </label>
    <input 
        type="email" 
        placeholder='Enter your email'    
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        />
    <div className="password">
        <label>Password : </label>
        <input 
            type={type} 
            placeholder='Enter your password'    
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            />
        <button onClick={changeType} className='eyeIcon'>&#128065;</button>
    </div>
    <button disabled={isLoading} onClick={handleSubmit}>Log In</button>
    {error && <p className='error'>{error}</p> }
   </form>
  )
}

export default Login